/** Latest selection wins; failed or superseded loads never replace a live model. */
export class FrameSwap {
  private revision = 0;
  cancel(): void { this.revision++; }
  async replace<T extends { dispose(): void }>(load: () => Promise<T>, commit: (frame: T) => void): Promise<boolean> {
    const revision = ++this.revision;
    const frame = await load();
    if (revision !== this.revision) { frame.dispose(); return false; }
    commit(frame);
    return true;
  }
}
